var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWestwardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 202 46.469",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "c",
    points: "0 0 3.5504 0 3.5504 12.881 0 12.881"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "b",
    points: "0 46.469 202 46.469 202 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100 -61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100 61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.619 0.08687 9.0454 9.1879 3.5504 3.6057 0.0028449 0.014941-4.5611 0.011384 11.481 11.662 2.7574 2.801-4.6678 0.012806 11.55 14.498-15.761-13.517-1.2539-1.0757 2.9985-0.0071146-18.31-14.485 3.6763-0.0064032-11.318-8.9538c-1.1301 1.5268-1.8079 3.4051-1.8079 5.4399v36.755h36.743c5.0511 0 9.1848-4.1343 9.1848-9.1879v-36.756h-33.309z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.665)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1.3897 -2.8459e-4 0 9.2744 3.5504 12.881",
    fill: "#FF683D",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "55.442 0.19146 59.01 0.19146 61.04 13.817 65.973 0.19146 69.355 0.19146 73.971 13.287 76.12 0.19146 79.581 0.19146 76.013 19.164 72.671 19.164 67.458 4.2781 61.862 19.164 58.559 19.164",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.555 10.991h5.9416v-0.10601c0-1.9281-0.97224-2.8921-2.9174-2.8921-1.857 0-2.8648 0.9989-3.0241 2.9981m3.0241-5.7579c4.2261 0 6.3399 2.1579 6.3399 6.4744 0 0.57487-0.039829 1.1497-0.11949 1.7246h-9.2445c0 1.9636 1.4409 2.9455 4.3242 2.9455 1.4054 0 2.8115-0.13233 4.2176-0.39771v2.7861c-1.2297 0.26538-2.724 0.39771-4.4836 0.39771-5.049 0-7.5731-2.3749-7.5731-7.1246 0-4.5377 2.1792-6.8059 6.539-6.8059",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.558 18.501v-2.9192c1.5469 0.61969 3.3335 0.92918 5.3584 0.92918 1.5121 0 2.2681-0.48593 2.2681-1.4592 0-0.92918-0.50853-1.3938-1.5249-1.3938h-2.5206c-2.8293 0-4.2446-1.3931-4.2446-4.1792 0-2.9184 2.0647-4.3777 6.1941-4.3777 1.751 0 3.4004 0.26538 4.9473 0.79542v2.9192c-1.5469-0.61898-3.2275-0.92846-5.0397-0.92846-1.9011 0-2.852 0.48664-2.852 1.4592 0 0.92846 0.55262 1.3931 1.6579 1.3931h2.2546c3.0953 0 4.6429 1.3931 4.6429 4.1792 0 2.9192-1.9722 4.3784-5.9153 4.3784-1.9367 0-3.6792-0.26538-5.2261-0.79613",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.95 2.9776h2.6002l0.52986 2.2554h3.5014v2.7861h-3.1166v6.4089c0 1.2999 0.56187 1.9501 1.6849 1.9501h1.4317v2.7861h-3.1294c-2.3342 0-3.5021-1.2515-3.5021-3.7544v-12.432z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.78 5.2332 121.32 5.2332 123.12 14.932 126.35 5.2332 129.36 5.2332 132.83 14.932 134.4 5.2332 138.06 5.2332 134.42 19.164 131.12 19.164 127.85 9.2793 124.53 19.164 121.17 19.164",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.57 13.061c-1.6892 0-2.5341 0.57487-2.5341 1.7246 0 1.2387 0.70767 1.8576 2.123 1.8576 1.1664 0 2.2496-0.36285 3.2489-1.0878v-2.229c-0.88405-0.17716-1.8307-0.26538-2.8378-0.26538m-6.0483 1.7644c0-2.7683 2.0156-4.1528 6.0483-4.1528 0.94593 0 1.8919 0.088934 2.8378 0.26538v-1.048c0-1.2472-0.89686-1.8712-2.692-1.8712-1.5213 0-3.2105 0.22198-5.0668 0.6638v-2.7861c1.8563-0.44253 3.5455-0.6638 5.0668-0.6638 4.1379 0 6.2069 1.5304 6.2069 4.5911v9.3401h-2.0419l-1.2475-1.2472c-1.2112 0.83171-2.5462 1.2472-4.0049 1.2472-3.4046 0-5.1066-1.4464-5.1066-4.3385",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.23 19.164v-13.931h2.719l0.43811 1.778c1.2198-1.1853 2.5106-1.778 3.8733-1.778v2.8395c-1.3094 0-2.4815 0.54427-3.5156 1.6321v9.4597h-3.5149z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.07 8.8684c-0.72545-0.47739-1.6358-0.71645-2.7325-0.71645-2.1835 0-3.2752 1.2251-3.2752 3.6754 0 2.9099 1.1358 4.3649 3.4089 4.3649 0.91961 0 1.7852-0.12806 2.5988-0.3849v-6.9389zm3.5142 9.4597c-2.1308 0.55779-4.2126 0.83597-6.2467 0.83597-4.5006 0-6.7509-2.4147-6.7509-7.2442 0-4.4581 2.202-6.6864 6.6051-6.6864 0.9374 0 1.8968 0.22055 2.8783 0.66309v-5.7053h3.5142v18.137z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "56.968 46.336 60.483 46.336 60.483 27.364 56.968 27.364",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.129 46.336v-13.931h2.719l0.43811 2.0426c1.3343-1.3617 2.8556-2.0426 4.5625-2.0426 3.2972 0 4.9466 1.7161 4.9466 5.1475v8.7831h-3.5149v-8.7831c0-1.5389-0.76457-2.3087-2.2944-2.3087-1.1401 0-2.2546 0.45605-3.342 1.3667v9.725h-3.5149z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.111 45.673v-2.9199c1.5469 0.6204 3.3335 0.92989 5.3584 0.92989 1.5121 0 2.2681-0.48593 2.2681-1.4599 0-0.92846-0.50853-1.3931-1.5256-1.3931h-2.5199c-2.8293 0-4.2446-1.3938-4.2446-4.1799 0-2.9177 2.0647-4.3777 6.1941-4.3777 1.751 0 3.4004 0.26538 4.9473 0.79542v2.9199c-1.5469-0.61898-3.2275-0.92918-5.0397-0.92918-1.9011 0-2.852 0.48736-2.852 1.4599 0 0.92775 0.55262 1.3923 1.6579 1.3923h2.2553c3.0945 0 4.6422 1.3938 4.6422 4.1799 0 2.9184-1.9722 4.3784-5.9153 4.3784-1.9367 0-3.6792-0.26538-5.2261-0.79613",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.507 30.15h2.5995l0.53057 2.2554h3.5014v2.7861h-3.1166v6.4089c0 1.2991 0.56116 1.9494 1.6842 1.9494h1.4324v2.7861h-3.1301c-2.3342 0-3.5014-1.2515-3.5014-3.7544v-12.431z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.53 46.336v-13.931h2.719l0.4374 1.7772c1.2198-1.1846 2.5113-1.7772 3.8733-1.7772v2.8388c-1.3087 0-2.4808 0.54498-3.5149 1.6321v9.4597h-3.5149z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.08 32.405v13.931h-2.7453l-0.4246-1.7772c-1.6003 1.1853-3.2987 1.7772-5.0931 1.7772-2.847 0-4.2709-1.684-4.2709-5.0543v-8.8763h3.5142v8.7838c0 1.5382 0.67282 2.308 2.0163 2.308 1.1408 0 2.3037-0.45605 3.4886-1.3667v-9.725h3.5149z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.4 46.336v-13.931h2.7183l0.41109 2.0163c1.2468-1.344 2.746-2.0163 4.4971-2.0163 1.7503 0 2.948 0.63605 3.5931 1.9103 1.4239-1.2742 2.9139-1.9103 4.4708-1.9103 3.2005 0 4.8008 1.7644 4.8008 5.2933v8.6372h-3.5149v-8.7695c0-1.5482-0.69842-2.3222-2.0953-2.3222-1.0434 0-2.0469 0.46957-3.0113 1.4066v9.6852h-3.5142v-8.7297c0-1.5738-0.64579-2.3621-1.9367-2.3621-1.0256 0-1.9936 0.46957-2.9046 1.4066v9.6852h-3.5142z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.05 38.164h5.9416v-0.10672c0-1.9274-0.97296-2.8921-2.9174-2.8921-1.857 0-2.8641 0.9989-3.0241 2.9988m3.0241-5.7586c4.2261 0 6.3399 2.1579 6.3399 6.4744 0 0.57487-0.04054 1.1504-0.11949 1.7253h-9.2445c0 1.9636 1.4409 2.9448 4.3242 2.9448 1.4061 0 2.8115-0.13162 4.2176-0.397v2.7861c-1.2297 0.26538-2.724 0.397-4.4829 0.397-5.0497 0-7.5731-2.3749-7.5731-7.1239 0-4.5377 2.1792-6.8066 6.5383-6.8066",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.06 46.336v-13.931h2.7183l0.43811 2.0426c1.335-1.3617 2.8556-2.0426 4.5632-2.0426 3.2972 0 4.9466 1.7161 4.9466 5.1475v8.7831h-3.5149v-8.7831c0-1.5389-0.76457-2.3087-2.2944-2.3087-1.1408 0-2.2546 0.45605-3.3428 1.3667v9.725h-3.5142z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.84 30.15h2.5995l0.52986 2.2554h3.5021v2.7861h-3.1173v6.4089c0 1.2991 0.56258 1.9494 1.6856 1.9494h1.4317v2.7861h-3.1294c-2.335 0-3.5021-1.2515-3.5021-3.7544v-12.431z",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.86 45.673v-2.9199c1.5469 0.6204 3.3328 0.92989 5.3577 0.92989 1.5121 0 2.2688-0.48593 2.2688-1.4599 0-0.92846-0.50853-1.3931-1.5256-1.3931h-2.5199c-2.8293 0-4.2453-1.3938-4.2453-4.1799 0-2.9177 2.0654-4.3777 6.1941-4.3777 1.751 0 3.4011 0.26538 4.9473 0.79542v2.9199c-1.5462-0.61898-3.2275-0.92918-5.039-0.92918-1.9011 0-2.852 0.48736-2.852 1.4599 0 0.92775 0.55191 1.3923 1.6579 1.3923h2.2546c3.0945 0 4.6422 1.3938 4.6422 4.1799 0 2.9184-1.9715 4.3784-5.9145 4.3784-1.9367 0-3.6792-0.26538-5.2261-0.79613",
    fill: "#fff",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.138 24.568 45.728 22.287 29.458 19.848 39.006 6.4472 25.777 16.229 25.218 12.895 20.657 12.907",
    fill: "#FF683D",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.761 27.281 18.36 19.844 0.77403 22.68 17.044 25.121 7.4972 38.521 20.725 28.739 23.446 44.969 26.016 28.363 24.762 27.288",
    fill: "#003B74",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.4505 12.796 8.9095 7.0485 9.401 7.4363-2.9992 0.0071147 1.2546 1.075 15.761 13.517-11.55-14.498 4.6678-0.012806-2.7574-2.8018-11.481-11.661 4.5611-0.012095-0.0028449-0.014229-3.5504-3.6064-9.0454-9.1872h-3.4338c-3.0192 0-5.7012 1.482-7.3782 3.7487l11.319 8.9538-3.6763 0.0064032z",
    fill: "#fff",
    mask: "url(#a)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWestwardWhite);
export default __webpack_public_path__ + "static/media/westward-white.c9a524e27cb473cfbe897aa225daff4e.svg";
export { ForwardRef as ReactComponent };